export const FETCH_TRENDING_TICKET_REQUEST = 'FETCH_TRENDING_TICKET_REQUEST';
export const FETCH_TRENDING_TICKET_SUCCESS = 'FETCH_TRENDING_TICKET_SUCCESS';
export const FETCH_TRENDING_TICKET_FAILURE = 'FETCH_TRENDING_TICKET_FAILURE';
